export default class Context {
    constructor({ level, value, parents }) {
        this.level = level;
        this.value = value;
        this.parents = parents;
    }

    initial_values() {
        return this;
    }

    static parse(data) {
        const level = data.context.length;
        const value = data.context[level - 1];
        const parents = data.context.slice(0, level - 1);
        return new Context({ level, value, parents });
    }

    get values() {
        if (this.level === 0) {
            return [];
        }
        return [...this.parents.map(p => p.value), this.value];
    }
}
